import React from "react";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import { EmptyState } from "../../../components/UI/States";
import { formatWhen } from "./accessUi";

const KIND_ICONS = {
  user: PersonRoundedIcon,
  page: LockOpenRoundedIcon,
  role: BadgeRoundedIcon,
};

// Changes made from Page Access and the User Manager, newest first.
const AuditList = ({ entries, compact = false, emptyText = "No changes yet." }) => {
  if (!entries?.length) {
    return <EmptyState compact icon={HistoryRoundedIcon} title={emptyText} />;
  }
  return (
    <ol className={compact ? "space-y-2" : "divide-y divide-[color:var(--app-divider)]"}>
      {entries.map((entry) => {
        const Icon = KIND_ICONS[entry.target?.kind] || HistoryRoundedIcon;
        return (
          <li key={entry._id} className={`flex gap-3 ${compact ? "" : "py-3"}`}>
            <span className="app-icon-tile mt-0.5 h-8 w-8 shrink-0 rounded-lg bg-slate-500/10 text-slate-500 dark:text-slate-300">
              <Icon sx={{ fontSize: 16 }} />
            </span>
            <div className="min-w-0">
              <p className="text-sm leading-snug">{entry.summary}</p>
              <p className="app-muted text-xs">
                {entry.by?.name || "Someone"} · {formatWhen(entry.at)}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default AuditList;
